// import React, { useState } from "react";
// import axios from "axios";
// import "./UserDeleteManagement.css";

// const UserDeleteManagement = () => {
//   const [phone, setPhone] = useState("");
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   // 🔍 Search User (GET API)
//   const handleSearch = async () => {
//     if (!phone) {
//       setError("Please enter phone number");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");
//       const response = await axios.get(
//         `http://localhost:5000/api/users?phone=${phone}`
//       );

//       if (response.data) {
//         setUser(response.data);
//       } else {
//         setUser(null);
//         setError("User not found");
//       }
//     } catch (err) {
//       setError("User not found");
//       setUser(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🗑 Delete User (DELETE API)
//   const handleDelete = async () => {
//     if (!user) return;

//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this user?"
//     );
//     if (!confirmDelete) return;

//     try {
//       await axios.delete(
//         `http://localhost:5000/api/users/${user.id}`
//       );

//       alert("User deleted successfully");
//       setUser(null);
//       setPhone("");
//     } catch (err) {
//       alert("Failed to delete user");
//     }
//   };

//   return (
//     <div className="container">
//       <div className="card">
//         <h2>User Delete Management</h2>
//         <p>Search for a user account to perform Delete actions.</p>

//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Enter phone number"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//           />
//           <button onClick={handleSearch}>Search User</button>
//         </div>

//         {loading && <p>Loading...</p>}
//         {error && <p className="error">{error}</p>}

//         {user && (
//           <div className="user-card">
//             <div className="avatar">
//               {user.name.charAt(0)}
//             </div>

//             <h3>{user.name}</h3>

//             <div className="details">
//               <div>
//                 <strong>Email:</strong> {user.email}
//               </div>
//               <div>
//                 <strong>Phone:</strong> {user.phone}
//               </div>
//               <div>
//                 <strong>Location:</strong> {user.location}
//               </div>
//             </div>

//             <button className="delete-btn" onClick={handleDelete}>
//               Delete User Account
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UserDeleteManagement;


// import React, { useState } from "react";
// import axios from "axios";
// import "./UserDeleteManagement.css";
// import { FiMail, FiPhone, FiMapPin, FiTrash2 } from "react-icons/fi";

// export default function UserDeleteManagement() {
//   const [phone, setPhone] = useState("");
//   const [user, setUser] = useState(null);
//   const [error, setError] = useState("");

//   const handleSearch = async () => {
//     if (!phone) return;

//     try {
//       const res = await axios.get(
//         `http://localhost:5000/api/users?phone=${phone}`
//       );
//       setUser(res.data);
//       setError("");
//     } catch (err) {
//       setUser(null);
//       setError("User not found");
//     }
//   };

//   const handleDelete = async () => {
//     if (!user) return;

//     if (!window.confirm("Are you sure you want to delete this user?"))
//       return;

//     await axios.delete(
//       `http://localhost:5000/api/users/${user.id}`
//     );

//     setUser(null);
//     setPhone("");
//   };

//   return (
//     <div className="delete-page">
//       <div className="search-card">
//         <h2>User Delete Management</h2>
//         <p>Search for a user account to perform Delete actions.</p>

//         <div className="search-wrapper">
//           <input
//             type="text"
//             placeholder="Enter phone number"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//           />
//           <button onClick={handleSearch}>Search User</button>
//         </div>
//       </div>

//       {user && (
//         <div className="user-card">
//           <div className="user-header">
//             <div className="avatar">
//               {user.name.charAt(0)}
//             </div>
//             <h3>{user.name}</h3>
//           </div>

//           <hr />

//           <div className="user-details">
//             <div>
//               <FiMail className="icon" />
//               <div>
//                 <label>EMAIL ADDRESS</label>
//                 <p>{user.email}</p>
//               </div>
//             </div>

//             <div>
//               <FiPhone className="icon" />
//               <div>
//                 <label>PHONE NUMBER</label>
//                 <p>{user.phone}</p>
//               </div>
//             </div>

//             <div>
//               <FiMapPin className="icon" />
//               <div>
//                 <label>LOCATION</label>
//                 <p>{user.location}</p>
//               </div>
//             </div>
//           </div>

//           <button className="delete-btn" onClick={handleDelete}>
//             <FiTrash2 /> Delete User Account
//           </button>
//         </div>
//       )}

//       {error && <p className="error-text">{error}</p>}
//     </div>
//   );
// }

import React, { useState } from "react";
import axios from "axios";
import "./UserDeleteManagement.css";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { FiTrash2 } from "react-icons/fi";

// import logo from '../../Images/logo.png';
import logo from '../Images/logo.png';

export default function UserDeleteManagement() {
    const [phone, setPhone] = useState("");
    const [user, setUser] = useState(null);

    const handleSearch = async () => {
        try {
            const res = await axios.get(
                `https://api.propertygalleria.in/master/api/delete/users?phone=${phone}`
            );
            setUser(res.data);
        } catch {
            setUser(null);
            alert("User not found");
        }
    };

    const handleDelete = async () => {
        if (!user) return;

        if (!window.confirm("Are you sure you want to delete?")) return;

        await axios.delete(
            `https://api.propertygalleria.in/master/api/delete/users/${user.id}`
        );

        setUser(null);
        setPhone("");
    };

    return (
        <>
            <header
                style={{
                    background: "linear-gradient(90deg, rgb(2, 82, 153) 0%, rgb(0, 51, 102) 100%)",
                    padding: "15px 40px",
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 10px",
                }}
            >
                <div
                    style={{
                        maxWidth: "1200px",
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                    }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            height: "50px",
                            borderRadius: "8px",
                            border: "2px solid rgb(250, 174, 47)",
                            backgroundColor:'white'
                        }}
                    />
                    <h1
                        style={{
                            fontSize: "24px",
                            fontWeight: 800,
                            color: "rgb(250, 174, 47)",
                            letterSpacing: "0.5px",
                            margin: 0,
                        }}
                    >
                        <span style={{ color: "#fff" }}>Property Galleria</span>
                    </h1>
                </div>
            </header>
            <div className="page">
                {/* Search Card */}
                <div className="search-card">
                    <h2>User Delete Management</h2>
                    <p>Search for a user account to perform Delete actions.</p>

                    <div className="search-row">
                        <input
                            type="text"
                            placeholder="Enter phone number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <button onClick={handleSearch}>Search User</button>
                    </div>
                </div>

                {/* User Card */}
                {user && (
                    <div className="user-card">
                        <div className="user-header">
                            {/* <div className="avatar">
              {user.full_name}
            </div> */}
                            <div className="avatar">
                                {user.profile_photo ? (
                                    <img
                                        src={user.profile_photo}
                                        alt={user.full_name}
                                        className="profile-img"
                                    // onError={(e) => {
                                    //     e.target.style.display = "none";
                                    // }}
                                    />
                                ) : (
                                    user.full_name?.charAt(0).toUpperCase()
                                )}
                            </div>
                            <h3>{user.full_name}</h3>
                            <p>{user.role}</p>
                        </div>

                        <div className="divider"></div>

                        <div className="info-row">
                            {/* <div className="info-box">
                            <p>{user.custom_id || ""}</p>
                            </div> */}

                            <div
                                className="info-box"
                                style={{ display: user?.custom_id ? "block" : "none" }}
                            >
                                <span>ID</span>
                                <p>{user?.custom_id}</p>
                            </div>
                            <div className="info-box">
                                <MdEmail className="icon" />
                                <div>
                                    <span>EMAIL ADDRESS</span>
                                    <p>{user.email}</p>
                                </div>
                            </div>

                            <div className="info-box">
                                <FaPhoneAlt className="icon" />
                                <div>
                                    <span>PHONE NUMBER</span>
                                    <p>{user.mobile_number}</p>
                                </div>
                            </div>

                            {/* <div className="info-box">
                            <FaMapMarkerAlt className="icon" />
                            <div>
                                <span>LOCATION</span>
                                <p>{user.location}</p>
                            </div>
                        </div> */}
                        </div>

                        <button className="delete-btn" onClick={handleDelete}>
                            <FiTrash2 /> Delete User Account
                        </button>
                    </div>
                )}
                {/* Footer */}
                <footer className="footer">
                    © 2026 LBN Property Galleria • Admin Portal
                </footer>
            </div>
        </>
    );
}